import PropTypes from 'prop-types';
export default {
  requiredIf: function requiredIf(type, condition) {
    return function (props) {
      var test = condition(props) ? type.isRequired : type;
      return test.apply(this, arguments);
    };
  },
  screenClass: PropTypes.oneOf(['xl', 'lg', 'md', 'sm', 'xs'])
};